import React, { Suspense, useState } from 'react';
import SuspenseComponent from '../../../views/components/SuspenseComponent';
import ReturnMachineTable from './ReturnMachineTable';
import ReturnMachineSubmitDateRange from './ReturnMachineSubmitDateRange';
import { getDeviceReturnMachineByRange } from "API";
import { useMutation, useQueryClient, } from 'react-query'
import { Row, Col } from "reactstrap";
const ReturnMachine = (props) => {
    const [valueDateRange, setValueDateRange] = useState([new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]);

    const [loading, setLoading] = useState(null);
    const queryClient = useQueryClient()
    const handleSubmit = () => {
        if (valueDateRange !== null) {
            if (valueDateRange[0] instanceof Date && valueDateRange[1] instanceof Date) {
                setLoading(true);
                mutation({ startRange: valueDateRange[0], endRange: valueDateRange[1] })
            }
        }
    }

    const { mutate: mutation } = useMutation(
        {
            mutationFn: getDeviceReturnMachineByRange,
            onSuccess: async (newData) => {

                setLoading(false);
                queryClient.setQueryData("ReturnMachineData", newData);
            }
        }
    );

    return (
        <>
            <div className="content">
                <Row>
                    <Col lg="3">
                        <h4>
                        Return Machine
                        </h4>
                    </Col>
                </Row>
                <ReturnMachineSubmitDateRange valueDateRange={valueDateRange} setValueDateRange={setValueDateRange} handleSubmit={handleSubmit} />

                <Suspense fallback={<SuspenseComponent />}>
                    <ReturnMachineTable loading={loading} valueDateRange={valueDateRange} />
                </Suspense>
            </div>
        </>
    );
};

export default ReturnMachine;
